import { AuthProvider } from '@refinedev/core';

import axiosInstance from '../utils/axios';

let _csrfToken: string | null = null;

async function getCsrfToken() {
  if (_csrfToken === null) {
    const response = await fetch(`/csrf`, {
      redirect: 'manual'
    });
    if (response.type === 'opaqueredirect') {
      window.location.href = '/login';
    }
    const data = await response.json();
    _csrfToken = data.csrfToken as string;
  }
  window['csrfToken'] = _csrfToken;
  return _csrfToken;
}

axiosInstance.interceptors.request.use(async config => {
  config.headers['X-CSRFToken'] = await getCsrfToken();
  return config;
});

// This dummy auth provider checks if we can retrieve the CSRF, if we do, we have the session cookie well set.
// TODO: Implement the rest of the properties when the auth is managed via JWT
const authProvider: AuthProvider = {
  login: async () => {
    return {
      success: true,
      redirectTo: '/'
    };
  },
  register: async () => {
    return {
      success: true,
      redirectTo: '/'
    };
  },
  forgotPassword: async () => {
    return {
      success: true,
      redirectTo: '/'
    };
  },
  updatePassword: async () => {
    return {
      success: true,
      redirectTo: '/'
    };
  },
  logout: async () => {
    return {
      success: true,
      redirectTo: '/logout'
    };
  },
  check: async () => {
    if (window['csrfToken']) {
      return {
        authenticated: true
      };
    }

    await getCsrfToken();
    if (window['csrfToken']) {
      return {
        authenticated: true
      };
    }
    return {
      authenticated: false
    };
  },
  onError: async () => {
    return {};
  },
  getPermissions: () => Promise.resolve(),
  getIdentity: () => Promise.resolve()
};

export default authProvider;
